import { postTransactionItems } from '@/apis/system';
import store from '@/store';
import _ from 'lodash';
import { makeSort } from '@/utils/array/makeSort';

/**
 * 加入或是新增已加入的變更項目
 * 此功能不會過濾掉做完至確認頁的項目 都會加進去喔
 * @param {Array|String} codeList ex: ['B5','B6'] or 'b5'
 */
const addService = async (codeList) => {
    if (typeof codeList === 'string') {
        codeList = [codeList];
    }
    const menuItems = _.cloneDeep(store.state.services.transactionItems);
    const noItem = codeList.filter(i => {
        const obj = menuItems.find(k => k.transactionItemNo === i && !k.userChecked);
        if (obj) { return i; }
    });
    let result = {};
    // 任一不在裡面之項目 打api加入變更項目
    if (noItem.length > 0) {
        result =
            await postTransactionItems(codeList).then((res) => {
                codeList.forEach(i => {
                    menuItems.forEach(j => {
                        if (j.transactionItemNo === i) {
                            j.userChecked = true;
                        }
                    });
                });
                store.dispatch('services/setTransactionItems', menuItems);
                // 過濾掉已經confirm的
                const list = res.data.menuItems.filter(k => {
                    const obj = menuItems.find(i => i.userChecked && i.transactionItemNo === k.transactionItemNo);
                    if (obj) { return k; }
                });
                // 更新操作流程 serviceList
                const services = list.map(i => {
                    const obj = menuItems.find(j => i.transactionItemNo === j.transactionItemNo);
                    i.routeName = obj.routeName;
                    i.confirm = obj.confirm;
                    return i;
                });
                store.dispatch('services/setServices', services);
                const obj = {
                    isNext: res.data.itemMsgList.length === 0,
                    itemMsgList: res.data.itemMsgList
                };
                return obj;
            }).catch(() => {
                return { isNext: false };
            });
    } else {
        // userChecked:true 存在該變更交易，判斷serviceList是不是已經有該變更項目
        // 已經有但是尚未做到
        const originServiceList = _.cloneDeep(store.state.services.serviceList);
        const list = [];
        codeList.forEach(k => {
            const hasItem = originServiceList.find(i => i.transactionItemNo === k);
            if (!hasItem) {
                const obj = menuItems.find(i => i.userChecked && i.transactionItemNo === k);
                if (obj) { list.push(obj); }
            }
        });
        const services = list.length > 0 ? makeSort([...list, ...originServiceList], 'transactionItemOrder') : originServiceList;
        store.dispatch('services/setServices', services);
        result.isNext = true;
    }
    return result;
};

export default addService;
